import { TStatus } from "utils/InterfaceAndTypeGeneral";

interface IAnswers {
  id: string;
  content: string;
}

interface IQuestion {
  score: number;
  isLastQuestion: boolean;
  answers: IAnswers[];
  id: string;
  content: string;
  order: number;
}
export interface IQuizzesParams {
  admissionExamId: string;
  quizId: string;
  status: TStatus;
  totalQuestions: number;
  remainingTime: number;
  question: IQuestion;
  title: string;
}

export default class QuizzesEntity {
  private readonly _admissionExamId: string;
  private readonly _quizId: string;
  private readonly _status: TStatus;
  private readonly _totalQuestions: number;
  private readonly _remainingTime: number;
  private readonly _question: IQuestion;
  private readonly _title: string;

  constructor(params: IQuizzesParams) {
    this._admissionExamId = params.admissionExamId;
    this._quizId = params.quizId;
    this._status = params.status;
    this._totalQuestions = params.totalQuestions;
    this._remainingTime = params.remainingTime;
    this._question = params.question;
    this._title = params.title;
  }

  public toJSON() {
    return {
      admissionExamId: this._admissionExamId,
      quizId: this._quizId,
      status: this._status,
      totalQuestions: this._totalQuestions,
      remainingTime: this._remainingTime,
      question: this._question,
      title: this._title,
    };
  }
}
